import React from 'react';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import { Slider } from 'Packages/FacetDesign/Components';
import { useSmartAllocationCustomizationContext } from '../../../../Context';
import Layout from './Layout';

const metaOverrideSet = buildFacetDesignOverride()
  .typeOverride('number', {
    _component: () => Slider,
  }, overrideReadOnly);

const AssumptionsForm = () => {
  const { refreshPageContentCollection } = usePageContentContext();
  const {
    smartAllocCustResource,
    refreshSmartAllocCustCollection,
  } = useSmartAllocationCustomizationContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  return (
    <MetaFormInline
      resource={smartAllocCustResource}
      layout={Layout}
      autoSave
      noIndividualSubmitButtons
      metaOverrideSet={metaOverrideSet}
      onSubmit={(resp) => {
        const [resource] = resp;
        logStandardizedEvent(categories.whatIf, eventTypes.changePicklist, 'set percent of remaining spent', { eventProperties: { value: resource.attr('remainingCashOnHandSpent') } });
        refreshSmartAllocCustCollection();
        refreshPageContentCollection();
      }}
      padding={'none'}
    />
  );
};

export default AssumptionsForm;
